import React from 'react';

import { IconEye, IconEyeCross } from '@edx/components/icons';

type UseRevealPasswordHook = {
  RevealPasswordIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  showPassword: boolean;
  toggleRevealPassword: () => void;
};

export const useRevealPassword = (): UseRevealPasswordHook => {
  const [showPassword, setShowPassword] = React.useState(false);
  const RevealPasswordIcon = showPassword ? IconEyeCross : IconEye;

  const toggleRevealPassword = (): void => setShowPassword(!showPassword);

  return {
    RevealPasswordIcon,
    showPassword,
    toggleRevealPassword,
  };
};
